export default "__VITE_ASSET__CAXGppob__"